import cert1 from './images/certificate/RVZK16Q5MPD5.jpg'
import cert2 from './images/certificate/72ZD2133VZYW.jpg'
import cert3 from './images/certificate/MEPJ559V6P3V.jpg'
import cert4 from './images/certificate/L4PQMM5GOZO1.jpg'

const certi = [
  {
    "id": 1,
    "title": "Menjadi Front-End Web Developer Expert",
    "image": cert1,
    "link": "https://www.dicoding.com/certificates/RVZK16Q5MPD5"
  },
  {
    "id": 2,
    "title": "Belajar Dasar Pemrograman Javascript",
    "image": cert2,
    "link": "https://www.dicoding.com/certificates/72ZD2133VZYW"
  },
  {
    "id": 3,
    "title": "Membangun Progressive Web Apps",
    "image": cert3,
    "link": "https://www.dicoding.com/certificates/MEPJ559V6P3V"
  },
  {
    "id": 4,
    "title": "Belajar Fundamental Front-End Web Development",
    "image": cert4,
    "link": "https://www.dicoding.com/certificates/L4PQMM5GOZO1"
  }
  
]

 export default certi;